export const managerDashboardPtBr = {
  header: {
    title: 'Painel do gestor',
    subtitle: 'Reembolsos das áreas que você lidera.',
    subtitleReimbursements:
      'Acompanhe os reembolsos das áreas que você lidera — priorizando aprovações, revisões e histórico no período.',
    subtitleCreditCards:
      'Visão consolidada dos reembolsos e faturas de todos os cartões — organizados por instituição e por cartão, sem perder o contexto ao navegar.',
    subtitleAreaAccounts:
      'Acompanhe as contas recorrentes e avulsas da área — organizadas por origem, vencimento e classificação gerencial.',
    subtitleContractOnly: 'Contratos da sua área ou marcados para você.',
    newReimbursement: 'Novo reembolso',
    export: 'Exportar',
  },
  reimbursementLinks: {
    title: 'Novo reembolso',
    description: 'Escolha como iniciar uma solicitação de reembolso.',
    publicLinks: 'Links disponíveis',
    noPublicLinks: 'Não há links públicos de reembolso disponíveis.',
    loading: 'Carregando links de reembolso…',
    open: 'Abrir',
    openInNewTab: 'Abrir em nova aba',
    loadError: 'Não foi possível carregar os links de reembolso.',
  },
  reimbursementDetails: {
    back: 'Voltar',
    backToBill: 'Voltar à conta',
    backToDocuments: 'Voltar aos documentos',
    backToDashboard: 'Voltar ao painel',
    permissionDeniedTitle: 'Sem permissão para ver este reembolso',
    permissionDenied:
      'Você não tem permissão para acessar esta solicitação. Peça ao administrador para conceder acesso.',
    notFoundTitle: 'Reembolso não encontrado',
    notFound: 'Esta solicitação não existe ou foi removida.',
    breadcrumb: 'Reembolso',
    pageTitle: 'Reembolso - {{name}} - {{amount}}',
    documentTitle: 'Reembolso: {{name}}',
    resizePanelsAria: 'Redimensionar painéis do comprovante e da revisão',
  },
  common: {
    recurring: 'Recorrente',
    onDemand: 'Avulso',
    notAvailable: 'Não informado',
  },
  filters: {
    competency: 'Competência',
    registrationMonth: 'Cadastro',
    previousMonth: 'Competência anterior',
    currentMonth: 'Competência selecionada',
    nextMonth: 'Próxima competência',
    scope: 'Escopo',
    scopeReimbursements: 'Escopo dos reembolsos',
    scopeCreditCards: 'Escopo dos cartões',
    scopeAreaAccounts: 'Escopo das contas',
    scopeTitle: 'Filtrar por escopo',
    scopeHint:
      'Departamentos e centros de custo selecionados são combinados por qualquer vínculo encontrado.',
    scopeReimbursementsTitle: 'Escopo dos reembolsos',
    scopeReimbursementsHint:
      'Mostra solicitações vinculadas a qualquer departamento ou centro de custo selecionado.',
    scopeCreditCardsTitle: 'Escopo dos cartões',
    scopeCreditCardsHint:
      'Mostra cartões vinculados ao cartão ou à área atual do portador em qualquer escopo selecionado.',
    scopeAreaAccountsTitle: 'Escopo das contas da área',
    scopeAreaAccountsHint:
      'Mostra contas cuja classificação AP contém qualquer departamento ou centro de custo selecionado.',
    scopeNoneSelected:
      'Nenhum filtro selecionado. Sem seleção, a visão mostra todo o escopo permitido.',
    scopeNoDepartments: 'Nenhum departamento disponível para este escopo.',
    scopeNoCostCenters: 'Nenhum centro de custo disponível para este escopo.',
    scopeClear: 'Limpar',
    scopeApply: 'Aplicar',
    departments: 'Departamentos',
    costCenters: 'Centros de custo',
  },
  kpis: {
    label: 'Indicadores do gestor',
    pendingApproval: { title: 'Aguardando aprovação' },
    awaitingYou: { title: 'Aguardando você' },
    reimbursementTotal: { title: 'Total no período' },
    reimbursementRejected: { title: 'Rejeitados' },
    reimbursementApproved: { title: 'Aprovados' },
    areaSpend: { title: 'Gasto da área no mês' },
    invoices: {
      title: 'Cartões para revisar',
      detail: '3 cartões na sua área',
    },
    trend: { title: 'Vs mês anterior' },
    pendingCount: '{{count}} pendentes',
    cardCount: '{{count}} cartões',
    invoicesAwaitingReview: '{{count}} cartões aguardando revisão',
    invoicesDueSoon: '{{count}} cartões com vencimento em até 7 dias',
    liveData: 'Dados em tempo real',
    trendLoading: 'Comparando com o mês anterior…',
    trendNoActivity: 'Sem reembolsos neste escopo na competência nem no mês anterior',
    trendNewBaseline: 'Sem lançamentos em {{month}} para comparar',
    trendUnchanged: 'Igual a {{month}}',
    trendAbove: '{{amount}} acima de {{month}}',
    trendBelow: '{{amount}} abaixo de {{month}}',
    trendMixedCurrency:
      'Totais em moedas diferentes ficam de fora da comparação com o mês anterior',
  },
  tabs: {
    reimbursements: 'Reembolsos',
    creditCards: 'Cartões de crédito',
    areaAccounts: 'Contas da área',
  },
  contractReviews: {
    title: 'Revisão de contratos',
    subtitle: 'Contratos da sua área ou marcados para você (revisor, responsável ou aprovação).',
    count: '{{count}} contrato(s)',
    loading: 'Carregando contratos…',
    loadError: 'Não foi possível carregar os contratos.',
    empty: 'Nenhum contrato da sua área ou marcado para você.',
    open: 'Abrir revisão',
    relevance: {
      PRIMARY_REVIEWER: 'Revisor',
      RESPONSIBLE: 'Responsável',
      PENDING_APPROVAL: 'Aprovação pendente',
      AREA_OWNER: 'Sua área',
    },
  },
  reimbursements: {
    loading: 'Carregando reembolsos…',
    request: 'Solicitação',
    all: 'Todos',
    unreviewed: 'Sem análise',
    review: 'Em revisão',
    approved: 'Aprovados',
    rejected: 'Reprovados',
    pending: 'Pendentes',
    mine: 'Aprovações para mim',
    history: 'Histórico',
    requester: 'Solicitante',
    description: 'Descrição',
    policy: 'Política',
    costCenter: 'Centro de custo',
    date: 'Data',
    amount: 'Valor',
    listAmountRequested: 'Solicitado {{amount}}',
    listAmountProposed: 'Aprovação {{amount}}',
    reason: 'Status',
    statusColumn: 'Status',
    billReference: 'Conta AP',
    origin: 'Origem',
    comment: 'Comentário',
    rejectionReasonColumn: 'Motivo da rejeição / comentário da aprovação',
    rejectionReasonMissing: 'Motivo não informado',
    emDash: '—',
    openHistoryDetailsAria: 'Abrir detalhes do reembolso: {{description}}',
    actions: 'Ações',
    registeredAt: 'Cadastro',
    dueDate: 'Vencimento',
    dueDateShort: 'Venc. {{date}}',
    supplier: 'Fornecedor',
    supplierNotIndicated: 'Estabelecimento não informado',
    classification: 'Classificação',
    aiColumn: 'Alertas',
    dates: 'Datas',
    activeFilters: 'Filtros ativos',
    clearAllFilters: 'Limpar todos',
    aiColumnTooltip:
      'Alertas apontados para este reembolso: autoaprovado, OK, atenção ou risco. Passe o mouse sobre um badge para ver o detalhe.',
    pagination: {
      empty: 'Nenhuma solicitação encontrada',
      range: '{{start}}–{{end}} de {{total}} solicitações',
    },
    bulkInstruction: 'Selecione reembolsos acionáveis por você para aprovar ou rejeitar em lote.',
    bulkSelected: '{{count}} selecionados',
    bulkApprove: 'Aprovar em lote',
    bulkReject: 'Reprovar em lote',
    bulkRejectDisabled: 'Use "Reprovar" na linha para informar o motivo em cada solicitação.',
    summaryPending: '{{count}} solicitações · {{amount}}',
    summaryMine: '{{count}} aprovações para mim',
    summaryHistory: '{{count}} itens revisados · bridge AP gerada',
    summaryAll: '{{count}} solicitações · {{amount}}',
    summaryUnreviewed: '{{count}} sem análise · {{amount}}',
    summaryReview: '{{count}} em revisão · {{actionable}} para você',
    summaryApproved: '{{count}} aprovados · {{amount}}',
    summaryRejected: '{{count}} reprovados · {{amount}}',
    classificationCostCenter: 'Centro de custo: {{value}}',
    classificationDepartment: 'Departamento: {{value}}',
    sortFilterHint: 'Ordenar e filtrar',
    sortByColumn: 'Ordenar por {{column}}',
    filterByColumn: 'Filtrar {{column}}',
    filterContainsPlaceholder: 'Buscar…',
    filterAmountMin: 'Valor mínimo',
    filterAmountMax: 'Valor máximo',
    filterApply: 'Aplicar',
    filterClear: 'Limpar',
    dueRelative: {
      today: 'vence hoje',
      inDays: 'em {{count}} dias',
      overdue: 'atrasado {{count}}d',
    },
    ai: {
      ok: 'OK',
      attention: 'Atenção — {{count}}',
      risks: 'Riscos — {{count}}',
      autoApproved: 'Autoaprovado',
      noFindings: 'Sem apontamentos',
      detailsTitle: 'Sinais da Alquim IA',
    },
    aiShort: {
      ai: 'IA',
      classification: 'Classificação',
      deadline: 'Prazo',
      limit: 'Limite',
      policy: 'Política',
      receipt: 'Comprovante',
      taxId: 'CNPJ',
      beneficiary: 'Beneficiário',
      amount: 'Valor',
      withExtra: '{{label}} +{{count}}',
    },
    aiDetails: {
      documentReuseWarning: 'Comprovante já usado em outra solicitação',
      duplicateDocumentAlreadyApproved:
        'Comprovante já aprovado em outro reembolso ou conta — reprovado automaticamente',
      policyBlocker: 'Revisão da política necessária',
      policyDecisionAlert: '{{message}}',
      weakPolicyMatch: 'Política sugerida com baixa confiança',
      ambiguousPolicyMatch: 'Mais de uma política possível',
      parseFallback: 'A IA não retornou uma resposta estruturada confiável',
      lowClassificationConfidence: 'Classificação com baixa confiança',
      receiptTotalExceedsRequested:
        'Valor total do comprovante é maior que o valor solicitado para reembolso',
      requesterNameMissingOnReceipt:
        'Comprovante não traz o nome do beneficiário (solicitante) de forma identificável',
      requesterNameMismatchOnReceipt:
        'Nome no comprovante não coincide com o solicitante do pedido',
    },
    supplierHints: {
      newVendor: 'Novo fornecedor',
      recurring: 'conta recorrente',
    },
    table: {
      policy: 'Política',
    },
    roles: {
      employee: 'Colaborador',
      vendor: 'Fornecedor',
      external: 'Externo',
    },
    fallback: {
      requester: 'Solicitante',
      description: 'Reembolso',
      policy: 'Política pendente',
      noPolicy: 'Sem política',
      costCenterSelected: 'Centro de custo selecionado',
      departmentSelected: 'Departamento selecionado',
      policyValidation: 'Aguardando aprovação da política',
      justification: 'Nenhuma justificativa informada',
      attachments: '{{count}} anexos',
      standaloneRequest: 'Solicitação avulsa',
      billReference: 'Conta {{billId}}',
    },
    flags: {
      autoApproved: 'Aprovado automaticamente',
      aiApprovedWithCaveat: 'Aprovado pela IA com ressalva',
      aiPolicyManualReview: 'Revisão manual exigida pela IA',
      exceedsPeriodLimit: 'Excede limite do período',
      exceedsTransactionLimit: 'Excede limite por transação',
      lateSubmission: 'Despesa fora do prazo da política',
      nearPeriodLimit: 'Limite do período quase atingido',
      noPolicyMatched: 'Nenhuma política compatível identificada',
      policyOverride: 'Política ajustada manualmente',
      taxIdEntityMissingOnDocument: 'Documento sem CNPJ da empresa',
    },
    empty: {
      title: 'Nenhum reembolso encontrado',
      pendingDescription:
        'Quando houver solicitações aguardando revisão, elas aparecerão aqui. Se a lista continuar vazia, configure políticas e fluxos de aprovação para reembolsos.',
      historyDescription: 'Reembolsos aprovados ou rejeitados aparecerão aqui após a revisão.',
    },
    loadErrorTitle: 'Não foi possível carregar os reembolsos',
    loadError: 'Tente novamente em instantes ou verifique sua conexão.',
    permissionDeniedTitle: 'Sem permissão para ver reembolsos',
    permissionDenied:
      'Você não tem permissão para acessar reembolsos neste escopo. Peça ao administrador para conceder acesso.',
    timeline: {
      requestCreated: 'Solicitação criada',
      linkedToBill: 'Vinculada a conta AP',
      standaloneCreated: 'Criada sem conta AP',
      rejectionRecorded: 'Rejeição registrada',
      rejectionReason: 'Motivo: {{reason}}',
      rejectionReasonMissing: 'Motivo não informado.',
      rejectionRecordedBy: 'Registado por {{name}}',
      requestMoreInfoRecorded: 'Pedido de informações registrado',
      requestMoreInfoMessage: 'Mensagem: {{message}}',
      requestMoreInfoMessageMissing: 'Texto da mensagem não disponível no histórico.',
      infoResponseRecorded: 'Resposta do solicitante registrada',
      infoResponseMessage: 'Resposta: {{message}}',
      infoResponseFields: 'Campos atualizados: {{fields}}',
      infoResponseAttachments: '{{count}} anexo(s) recebido(s)',
      infoResponseNoDetail: 'Resposta recebida sem detalhes adicionais.',
      approvalFinalRecorded: 'Aprovação final registrada',
      approvalManualRecorded: 'Aprovação manual registrada',
      approvalStepTitle: 'Etapa de aprovação',
      approvalStepRecorded: 'Etapa {{stepNumber}} — {{stepName}}',
      approvalCommentLine: 'Comentário: {{comment}}',
      approvalAmountLine: 'Valor aprovado: {{amount}}',
      approvalNoExtraDetail: 'Aprovação registrada sem comentário adicional.',
      billConversionRecorded: 'Convertido em conta AP',
      documentReuseRecorded: 'Comprovante reutilizado',
      documentReuseLine: '{{documentName}} já foi usado em outra solicitação: {{requestIds}}',
      reviewDetailsUpdated: 'Detalhes do reembolso atualizados',
      reviewUpdateSummaryFallback: 'Alterações nos detalhes foram guardadas.',
      reviewLineMerchantName: 'Estabelecimento: {{value}}',
      reviewLineMerchantTaxId: 'CNPJ/CPF: {{value}}',
      reviewLineMerchantVendorId: 'Fornecedor (ID): {{value}}',
      reviewLineTags: 'Etiquetas: {{value}}',
      reviewLineDueDate: 'Data prevista do reembolso: {{value}}',
      reviewLineReviewerApprovedAmount: 'Valor aprovado (revisão): {{amount}}',
      reviewLineDepartment: 'Departamento: {{value}}',
      reviewLineCostCenter: 'Centro de custo: {{value}}',
      reviewLineSegments: 'Classificação: {{value}}',
      reviewLineCustomFields: 'Campos adicionais: {{value}}',
    },
    status: {
      managerApproval: 'Sua aprovação',
      overdueShort: 'Atrasado 3d',
      autoApprovable: 'Aprovado',
      awaitingInfo: 'Aguardando solicitante',
      infoReceivedAwaitingManager: 'Gestor · info recebida',
      awaitingManagerTriage: 'Gestor · triagem sem política',
      awaitingManagerReview: 'Gestor · aguardando revisão',
      systemAiPolicyReview: 'IA · revisão de política',
      workflowAwaitingApprovers: 'Workflow · outro aprovador',
      workflowAwaitingYou: 'Workflow · sua etapa',
      systemBillWorkflow: 'Sistema · workflow AP',
      autoApprovedBySystem: 'Sistema · autoaprovado',
      approvedByManager: 'Gestor · aprovado',
      convertedToBill: 'Conta a pagar criada',
      rejected: 'Reprovado',
      actionableByCurrentUser: 'Sua ação',
      noPolicyPendingReview: 'Gestor · triagem sem política',
      policyPendingApproval: 'Em revisão',
      billWorkflowFallback: 'Sistema · workflow AP',
      autoApproved: 'Sistema · autoaprovado',
      policyApproved: 'Aprovado',
      infoReceived: 'Gestor · info recebida',
    },
  },
  status: {
    managerApproval: 'Sua aprovação',
    overdueDays: 'Atrasado {{count}}d',
    autoApprovable: 'Aprovado',
  },
  historyStatus: {
    approved: 'Aprovado',
    rejected: 'Rejeitado',
  },
  creditCards: {
    title: 'Cartões da área',
    subtitle: 'Selecione um cartão para revisar a fatura.',
    subtitleWithReviewCount: '{{count}} de {{total}} cartões aguardando revisão.',
    activeCount: '{{count}} cartões ativos',
    searchPlaceholder: 'Buscar por instituição, cartão ou titular...',
    searchEmpty: 'Nenhum cartão encontrado para essa busca.',
    openInvoice: 'Fatura aberta',
    closedInvoice: 'Fatura fechada',
    limit: 'Limite',
    available: 'Disponível',
    noPeriodStatement: 'Sem fatura no período',
    emptyScopeTitle: 'Nenhum cartão neste escopo',
    emptyScopeDescription:
      'Ajuste departamentos ou centros de custo para ver cartões vinculados ao cartão ou à área atual do portador.',
    invoiceBadge: {
      open: 'Aberta',
      closed: 'Fechada',
      paid: 'Paga',
      reviewed: 'Revisada',
      active: 'Ativo',
      inactive: 'Inativo',
    },
    cardBadge: {
      reviewed: 'Cartão revisado',
      pending: 'Cartão aguardando revisão',
    },
    navigation: {
      overview: 'Visão geral',
      institutions: 'Instituições',
      footer: '{{institutions}} instituições · {{cards}} cartões ativos',
    },
    overview: {
      title: 'Instituições e cartões',
      subtitle: 'Acompanhe pendências, limites e faturas abertas antes de entrar nos detalhes.',
      summary: '{{institutions}} instituições · {{cards}} cartões ativos',
      byInstitution: 'Por instituição',
      byInstitutionHint: '— clique para ver os cartões de cada uma',
      pendingBadge: '{{count}} pendências',
      openTotal: 'total em faturas abertas',
      activeCards: '{{count}} cartões ativos',
      limitPercent: '{{percent}} do limite',
    },
    institution: {
      subtitle: 'Cartões ativos desta instituição no período selecionado.',
      summary: '{{cards}} cartões ativos · {{pending}} pendências',
    },
    card: {
      cardSubtitle: 'cartão {{brand}}',
      summary: '{{amount}} em aberto · {{limit}} de limite',
    },
    metrics: {
      totalOpen: 'Total em faturas abertas',
      totalLimit: 'Limite total',
      activeCards: 'Cartões ativos',
      reviewedStatements: 'Faturas revisadas',
      reviewedCards: 'Cartões revisados',
      pendingReview: 'Pendentes de revisão',
      cardsAndInstitutions: '{{cards}} cartões · {{institutions}} instituições',
      activeCardsDetail: '{{count}} cartões ativos',
      utilized: '{{percent}} utilizado no período',
      institutions: 'Distribuídos em {{count}} instituições',
      awaitingAction: '{{count}} aguardando ação',
      pendingAmount: '{{amount}} em transações pendentes',
    },
    insights: {
      periodTitle: 'Insights do período',
      institutionTitle: 'Insights da instituição',
      total: 'Total do período',
      totalDetail: 'Consolidado das faturas abertas',
      topInstitution: 'Instituição com maior volume',
      topCard: 'Cartão com maior fatura',
      pendingReview: 'Pendentes de revisão',
      pendingAmount: '{{amount}} em transações pendentes',
      openAmount: '{{amount}} em faturas abertas',
      noData: 'Sem dados no período',
      newCards: 'Cartões novos no período',
      newCardsDetail: 'Nenhum cartão novo identificado neste período.',
      overThirty: 'Utilização acima de 30%',
      overThirtyDetail: 'Considera o percentual de limite utilizado no período.',
      none: 'Nenhum',
    },
    table: {
      allCardsTitle: 'Todos os cartões',
      sortedByOpenInvoice: '— ordenados por fatura aberta',
      institutionCardsTitle: 'Cartões',
      clickCardHint: '— clique em um cartão para ver a fatura',
      institution: 'Instituição',
      card: 'Cartão',
      lastFour: 'Final',
      openInvoice: 'Fatura aberta',
      limit: 'Limite',
      status: 'Status',
    },
    statementNavigation: {
      previous: 'Fatura anterior',
      next: 'Próxima fatura',
    },
    statementSelector: {
      label: 'Fatura',
      placeholder: 'Selecione a fatura do período',
    },
    statementHeader: {
      title: 'Fatura selecionada',
      period: 'Período {{period}}',
      closing: 'Fechamento',
      due: 'Vencimento',
      transactions: 'Transações',
      vendors: 'Fornecedores',
      transactionCount: '{{count}} transações',
      vendorCount: '{{count}} fornecedores',
      status: {
        open: 'Aberta',
        closed: 'Fechada',
        paid: 'Paga',
        reviewed: 'Revisada',
        cardReviewed: 'Cartão revisado',
      },
    },
    reviewBannerTitle: 'Fatura fechada — aguardando sua revisão',
    reviewBannerOpenTitle: 'Fatura aberta — aguardando sua revisão',
    reviewedBannerTitle: 'Fatura revisada',
    reviewDueDate: 'Vencimento {{date}}',
    markReviewedButton: 'Marcar como revisado',
    reviewedButton: 'Revisado',
    cardReviewBannerTitle: 'Cartão aguardando revisão',
    cardReviewBannerOpenTitle: 'Cartão aguardando revisão',
    cardReviewedBannerTitle: 'Cartão revisado',
    invoiceReviewedBannerTitle: 'Fatura revisada',
    markCardReviewedButton: 'Marcar cartão como revisado',
    undoCardReviewButton: 'Desfazer revisão do cartão',
    invoiceReviewProgress: '{{reviewed}} de {{total}} cartões revisados',
    unresolvedInvoiceTransactions: '{{count}} transações sem cartão identificável',
    loading: 'Carregando fatura e transações reais…',
    loadError: 'Não foi possível carregar os dados reais do cartão.',
    emptyCardsTitle: 'Nenhum cartão corporativo encontrado',
    emptyCardsDescription:
      'Cadastre cartões em Operacional > Cartões de crédito ou conecte uma integração para acompanhar faturas reais aqui.',
    emptyStatementTitle: 'Nenhuma fatura encontrada para este cartão',
    emptyStatementDescription:
      'Importe ou sincronize o extrato do cartão para liberar transações, insights e revisão persistida.',
    reviewSaved: 'Fatura marcada como revisada.',
    reviewSaveFailed: 'Não foi possível marcar a fatura como revisada.',
    cardReviewSaved: 'Cartão marcado como revisado.',
    cardReviewReverted: 'Revisão do cartão desfeita.',
    observationSaved: 'Observação salva na transação.',
    cardItemApproved: 'Transação marcada como ciente.',
    acknowledgedAnnotationContent: 'Transação marcada como ciente pelo gestor.',
    improperReasonSaved: 'Motivo registrado na transação.',
    improperReasonAnnotationContent:
      'Transação marcada como indevida pelo gestor. Motivo: {{reason}}',
    cardholderQuestionSaved: 'Pergunta registrada para o responsável do cartão.',
    annotationSaveFailed: 'Não foi possível salvar a anotação.',
    cardItemIgnored: 'Transação marcada como indevida.',
    cardItemIgnoreFailed: 'Não foi possível marcar a transação como indevida.',
    comparison: {
      currentTitle: '{{date}} (este período)',
      currentSubtitle: '{{transactions}} transações · {{vendors}} fornecedores',
      previousTitle: '{{date}}',
      previousSubtitle: '{{transactions}} transações · {{vendors}} fornecedores',
      noPreviousTitle: 'Sem fatura anterior',
      noPreviousSubtitle: 'Importe períodos anteriores para comparar',
      empty: 'Sem transações categorizadas para comparar.',
    },
    transactions: {
      title: 'Transações da fatura',
      helper: '{{count}} transações · clique para revisar detalhes',
      empty: 'Nenhuma transação encontrada nesta fatura.',
      loadMore: 'Carregar mais transações',
      loadingMore: 'Carregando…',
      columns: {
        date: 'Data',
        merchant: 'Estabelecimento',
        apClassification: 'Classificação',
        accounting: 'Contas',
        organization: 'Centro/Depto',
        categorization: 'Categoria',
        installment: 'Parcela',
        reviewStatus: 'Revisão',
        amount: 'Valor',
        action: 'Ação',
      },
      apClassification: {
        classified: 'Classificação',
        imported: 'Classificação pendente',
        reconciledWithAp: 'Conciliada com AP',
        pendingBillClassification: 'Classificação pendente',
        reconciled: 'Conciliada',
        uncategorized: 'Sem classificação AP',
        infoRequested: 'Aguardando informação',
        improper: 'Indevida',
        categoryHint: 'Categoria do cartão: {{category}}',
        openLinkedBill: 'Abrir conta {{billId}}',
        linkedBillVendor: 'Fornecedor: {{vendor}}',
      },
      reviewStatus: {
        pending: 'Pendente',
        acknowledged: 'Ciente',
        improper: 'Indevida',
      },
    },
  },
  cards: {
    insights: {
      title: 'Insights da fatura',
      newVendors: 'Fornecedores novos',
      increasedVendors: 'Subiram mais que 30%',
    },
  },
  areaAccounts: {
    title: 'Contas da área · Janeiro 2026',
    subtitle: 'Recorrentes e avulsas com origem da despesa.',
    summary: '{{count}} contas · {{amount}}',
    metrics: {
      total: 'Total em contas',
      totalDetail: '{{count}} contas no período',
      recurring: 'Recorrentes',
      recurringDetail: '{{count}} contas recorrentes',
      onDemand: 'Avulsas',
      onDemandDetail: '{{count}} contas avulsas',
      average: 'Ticket médio',
      averageDetail: 'Média por conta no período',
    },
    recurringHeading: 'Recorrentes — {{amount}} (64% do gasto)',
    onDemandHeading: 'Avulsas — {{amount}} (36% do gasto)',
    table: {
      vendor: 'Fornecedor',
      description: 'Descrição',
      managerialAccount: 'Conta gerencial',
      dueDate: 'Vencimento',
      status: 'Status',
      origin: 'Origem',
      vsDecember: 'Vs Dez',
      amount: 'Valor',
    },
    status: {
      paid: 'Pago',
      scheduled: 'Agendado',
      inApproval: 'Em aprovação',
    },
    origin: {
      manual: 'Manual',
      card: 'Cartão',
      reimbursement: 'Reembolso',
    },
    fallback: {
      vendor: 'Conta',
      description: 'Conta da área',
      reimbursementAccount: 'Reembolso',
      expenseAccount: 'Despesa',
    },
  },
  tables: {
    category: 'Categoria',
  },
  drawers: {
    reimbursement: {
      title: 'Revisar reembolso',
      description: 'Validação de política, comprovante e trilha de auditoria.',
      detailTitle: 'Detalhes do reembolso',
      detailDescription: 'Validação da política, recibo e histórico de auditoria.',
      noPendingAction: 'Nenhuma etapa pendente para sua aprovação.',
      rejectedReadOnlyFooter:
        'Este pedido já foi rejeitado. Não é possível aprovar, rejeitar nem pedir informações de novo aqui.',
      rejectedChainCannotReopen:
        'Este pedido foi reprovado por uma etapa formal de aprovação e não pode ser reaberto por aqui; peça a um aprovador para iniciar uma nova aprovação.',
      amount: 'Valor solicitado',
      approvedAmount: 'Valor aprovado',
      approvedAmountHint: 'Máx. valor solicitado.',
      approvedAmountHintFull:
        'Valor efetivamente aprovado para reembolso. Não pode ser maior que o valor solicitado.',
      approvedAmountReadOnly: 'Não é possível alterar após gerar a conta a pagar.',
      validationDecisionTitle: 'Sua decisão',
      policyFrameTitle: 'Política',
      accountingClassificationTitle: 'Classificação contábil',
      viewPolicy: 'Ver política',
      viewPolicyAria: 'Abrir política {{name}} em nova aba',
      viewPolicyDescription: 'Ver descrição da política',
      policyDescriptionSection: 'Descrição',
      policyAiTextSection: 'Regras da política (IA)',
      policyJustificationSection: 'Orientações para justificativa',
      policyNoDescription: 'Esta política não tem descrição cadastrada.',
      linkedApBillLabel: 'Conta a pagar vinculada',
      linkedBillSentToAp: 'Reembolso aprovado e enviado para o fluxo de contas a pagar.',
      linkedBillPendingApFinalization:
        'Reembolso aprovado. A conta está pendente no fluxo AP/contábil para validação, aprovação final, provisão GL e pagamento.',
      linkedBillLink: 'Abrir conta {{billId}}',
      linkedBillLinkAria: 'Abrir conta a pagar {{billId}}',
      contactPayment: 'Contato e pagamento',
      requesterLabel: 'Solicitante',
      merchantLabel: 'Estabelecimento',
      merchantTaxIdLabel: 'CNPJ do estabelecimento',
      expenseCategoryLabel: 'Categoria',
      receiptMethodLabel: 'Recebimento',
      requesterEmail: 'E-mail do solicitante',
      pixKey: 'Chave Pix',
      payoutMethod: 'Forma de recebimento',
      payoutDetails: 'Dados para pagamento',
      submittedAt: 'Data da solicitação',
      reimbursementDueDateLabel: 'Data prevista do reembolso',
      reimbursementDueDateHint: 'Previsão de pagamento.',
      reimbursementDueDateHintFull:
        'Data prevista para realizar o reembolso ao beneficiário aprovado.',
      reimbursementDueDateReadOnly: 'Não é possível alterar após gerar a conta a pagar.',
      datesSectionTitle: 'Datas',
      notProvided: 'Não informado',
      validation: 'Validação da política',
      policyApprovalTitle: 'Política e aprovação',
      policyAppliedBadge: 'Aplicada',
      policyMissingBadge: 'Sem política',
      policyResultLabel: 'Resultado',
      policyResultNoPolicy: 'Nenhuma política aplicada',
      approverConfigurationIssueTitle: 'Nenhum aprovador configurado',
      approverConfigurationIssueDescription:
        'A política exige aprovação, mas a etapa não tem usuários responsáveis. Configure autoridades de aprovação ou aprovadores da política para destravar este reembolso.',
      policyDecisionTitle: 'Decisão da política',
      viewWhyAnalysisStopped: 'Ver por que a análise parou',
      unknownPolicyBlocker: 'A análise da política exige revisão.',
      pendingPolicyMismatchTitle: 'A política aplicada não corresponde à despesa',
      pendingPolicyMismatchDescription:
        'Troque a política para que a análise use as regras corretas desta solicitação.',
      pendingManualReviewTitle: 'A análise automática requer sua revisão',
      pendingManualReviewDescription:
        'Confira as evidências antes de decidir; esta sinalização não impede uma aprovação justificada.',
      pendingDependentInformationTitle: 'Faltam dados para avaliar dependentes',
      pendingDependentInformationDescription:
        'A política depende de informações do beneficiário que não foram identificadas na solicitação.',
      pendingGenericPolicyDescription: 'Revise esta condição antes de aprovar o reembolso.',
      pendingPolicyMissingTitle: 'Nenhuma política foi aplicada',
      pendingPolicyMissingDescription: 'Selecione a política adequada para avaliar esta despesa.',
      pendingBeneficiaryTitle: 'Beneficiário do reembolso não definido',
      pendingBeneficiaryDescription:
        'Selecione o colaborador ou fornecedor que receberá o pagamento.',
      pendingMerchantTitle: 'Fornecedor não vinculado no ERP',
      pendingMerchantDescription:
        'Vincule o estabelecimento para permitir a criação da conta a pagar.',
      pendingClassificationTitle: 'Classificação contábil incompleta',
      pendingClassificationDescription:
        'Preencha os campos obrigatórios da classificação antes de aprovar.',
      decisionPendingItemsOne: '1 pendência antes de aprovar',
      decisionPendingItemsOther: '{{count}} pendências antes de aprovar',
      approveWithPendingOne: 'Aprovar com 1 pendência',
      approveWithPendingOther: 'Aprovar com {{count}} pendências',
      policyDecision: {
        APPROVE_AUTOMATICALLY: 'Autoaprovar',
        REQUEST_APPROVAL: 'Solicitar aprovação',
        REQUEST_MORE_INFO: 'Pedir informações',
        ALERT_ONLY: 'Gerar alerta',
        MANUAL_REVIEW: 'Revisão manual',
        REJECT_AUTOMATICALLY: 'Reprovar automaticamente',
      },
      policyDecisionReason: {
        MANUAL_REVIEW: 'Falha na avaliação automática; revisão manual necessária.',
      },
      policyDecisionAlert: {
        AI_PARSE_FALLBACK:
          'A saída da IA para a política estava inválida ou indisponível; a revisão manual é necessária.',
        AI_LOW_CONFIDENCE: 'A confiança da IA está abaixo do limite para aprovação automática.',
        AI_REQUESTED_MANUAL_REVIEW: 'A avaliação da IA solicitou revisão manual.',
        POLICY_CATEGORY_MISMATCH:
          'A categoria da política de IA não corresponde à categoria do reembolso.',
        AI_APPROVAL_WITH_CAVEAT:
          'A IA aprovou com ressalvas; por padrão é necessária revisão do gestor.',
        AI_DEPENDENT_EVALUATION_MISSING:
          'A política cita dependentes, mas a IA não retornou avaliação de dependentes.',
        DEPENDENT_REQUESTER_NOT_EMPLOYEE:
          'A avaliação por dependente exige que o solicitante esteja vinculado a um colaborador.',
        DEPENDENT_DATA_NOT_FOUND:
          'Nenhum dependente ativo foi encontrado para o colaborador solicitante.',
        DEPENDENT_INFORMATION_MISSING: 'Faltam informações para validar a regra de dependentes.',
        DEPENDENT_MATCH_MISSING: 'Nenhum dependente foi identificado claramente na solicitação.',
        DEPENDENT_MATCH_INVALID: 'A IA identificou dependentes que não existem no contexto de HCM.',
        DEPENDENT_BIRTH_DATE_MISSING:
          'Um dependente identificado não possui data de nascimento para validar faixa etária.',
        DEPENDENT_LIMIT_MISSING:
          'A regra monetária por dependente exige um limite calculado para aprovação automática.',
        DEPENDENT_LIMIT_EXCEEDED:
          'O valor solicitado excede o limite calculado pela regra de dependentes.',
        DOCUMENT_REUSE_WARNING:
          'Um ou mais comprovantes deste reembolso já foram usados em outra solicitação.',
        DUPLICATE_DOCUMENT_ALREADY_APPROVED:
          'O comprovante já foi utilizado em reembolso ou conta a pagar aprovada; a solicitação foi reprovada automaticamente para evitar pagamento em duplicidade.',
        AI_POLICY_REJECTED:
          'A política avaliou esta solicitação como fora das regras e reprovou automaticamente.',
        AI_SELECTED_FROM_AMBIGUOUS_POLICIES:
          'Mais de uma política poderia ser aplicada; a IA selecionou a mais coerente e manteve para revisão manual.',
        AI_REJECTION_REQUIRES_REVIEW:
          'A reprovação pela IA é apenas indicativa até existir uma política explícita de reprovação automática.',
      },
      dependentEvaluationTitle: 'Avaliação de dependentes',
      dependentEvaluationMatchedCount: '{{count}} dependente(s)',
      dependentEvaluationLimit: 'Limite calculado',
      dependentEvaluationCriteria: 'Critérios',
      policyExcessAmount: 'Excedente',
      policyNoExcess: 'Dentro do limite',
      approvalChainDetailsTitle: 'Ver cadeia completa',
      noPolicyWarning:
        'Nenhuma política compatível foi identificada. Selecione uma política para reenviar ao fluxo de aprovação.',
      policySuggestionTitle: 'Política sugerida',
      policySuggestionManualReviewHint:
        'A política pode ser aplicada, mas a avaliação indica revisão manual (ex.: faixa de valor).',
      applySuggestedPolicy: 'Aplicar sugestão',
      policySuggestionReason: {
        POLICY_SUGGEST_CATEGORY_ID_MATCH: 'Categoria do pedido coincide com a da política.',
        POLICY_SUGGEST_CATEGORY_LABEL_MATCH: 'Nome da categoria coincide com a política.',
        POLICY_SUGGEST_CATEGORY_LABEL_PARTIAL:
          'Categoria parcialmente alinhada ao rótulo da política.',
        POLICY_SUGGEST_AI_CATEGORY_GATE: 'Categoria compatível com a política de IA.',
        POLICY_SUGGEST_AI_CATEGORY_WEAK: 'Categoria com correspondência fraca na política de IA.',
        POLICY_SUGGEST_WORKFLOW_MATCH: 'Condições do workflow da política foram atendidas.',
        POLICY_SUGGEST_AI_APPROVED: 'IA indicou aprovação automática.',
        POLICY_SUGGEST_AI_APPROVED_WITH_RESERVATION:
          'IA aprovou com ressalvas — revisão manual provável.',
        POLICY_SUGGEST_AI_MANUAL_REVIEW: 'IA solicitou revisão manual.',
        POLICY_SUGGEST_AI_REJECTED: 'IA indicou reprovação.',
      },
      policySuggestionUnknownReason: 'A política foi sugerida pela análise automática.',
      requestedAmount: 'Valor solicitado',
      effectivePolicyLimit: 'Limite efetivo',
      policyUsedInPeriod: 'Usado no período',
      policyRemainingMargin: 'Margem restante',
      selectPolicy: 'Selecionar política',
      policyAutoApplyHint: 'A política é aplicada automaticamente ao selecionar.',
      clearPolicySelection: 'Sem política',
      applyPolicy: 'Aplicar política',
      changePolicy: 'Trocar política',
      allowLimitOverrideLabel:
        'Autorizar valor acima do limite da política (fica registrado na avaliação)',
      allowLimitOverrideHint:
        'Use apenas quando o valor proposto pelo gestor excede o limite efetivo; o pedido continua auditável no histórico e nos metadados.',
      limitOverrideRecorded:
        'Limite da política foi excedido de forma explícita na última avaliação (override registrado).',
      policyOverrideComment: 'Comentário sobre a troca de política...',
      approvalChainTitle: 'Cadeia de aprovação',
      approvalChainStatus: 'Status da cadeia: {{status}}',
      approvalStepLabel: 'Etapa {{number}} — {{name}}',
      approvalNoApprovers: 'Sem aprovadores resolvidos',
      justification: 'Justificativa',
      receipt: 'Comprovante',
      timeline: 'Linha do tempo',
      expenseDetailsTitle: 'Despesa',
      historyTitle: 'Histórico',
      askInfo: 'Mensagem ao solicitante',
      askInfoHelper:
        'Use esta mensagem para pedir informações ou justificar uma rejeição. Para aprovar, o comentário é opcional.',
      askInfoPlaceholder: 'Escreva o que falta para aprovar ou o motivo da rejeição...',
      askInfoHistory: 'Histórico de mensagens ao solicitante',
      askInfoHistoryEmpty: 'Nenhuma mensagem enviada ao solicitante ainda.',
      askInfoHistoryRoleManager: 'Gestor',
      askInfoHistoryRoleRequester: 'Solicitante',
      tabInformation: 'Informações',
      tabValidation: 'Validação',
      tabRequest: 'Solicitação',
      tabClassification: 'Classificação',
      tabTimeline: 'Linha do tempo',
      tabStateOk: 'OK',
      tabStatePending: 'Pendente',
      tabStateAction: 'Ação',
      requestReadOnlyFooter: 'Aba somente leitura. Use Validação para interagir com o reembolso.',
      reviewFields: 'Classificação da revisão',
      aiSuggestedClassification: 'Sugestão automática',
      reviewTags: 'Etiquetas',
      reviewTagsPlaceholder: 'Nova etiqueta',
      reviewTagsHint: 'Digite o texto e pressione Enter ou vírgula para adicionar.',
      reviewTagsRemoveAria: 'Remover etiqueta',
      reviewCategory: 'Categoria',
      reviewCategoryPlaceholder: 'Ex.: Software e Tecnologia',
      expenseCategoryVsApHint:
        'A categoria informada pelo solicitante orienta políticas e intake. A classificação AP (departamento, centro de custo, etc.) é definida na aba Classificação e usada na conta a pagar.',
      reviewDepartment: 'Departamento',
      reviewDepartmentPlaceholder: 'Selecione um departamento',
      reviewCostCenter: 'Centro de custo',
      reviewCostCenterPlaceholder: 'Selecione um centro de custo',
      reviewGlAccount: 'Conta contábil',
      reviewGlAccountPlaceholder: 'Selecione uma conta contábil',
      reviewManagerialAccount: 'Conta gerencial',
      reviewManagerialAccountPlaceholder: 'Selecione uma conta gerencial',
      reviewCustomFieldsTitle: 'Campos customizados',
      reviewCustomFieldsHint: 'Segmentos adicionais da classificação (como na conta a pagar).',
      saveReview: 'Salvar revisão',
      reviewSaved: 'Revisão salva',
      dueDateSaved: 'Data prevista atualizada',
      approvedAmountSaved: 'Valor aprovado atualizado',
      merchantSaved: 'Estabelecimento atualizado',
      merchantCreated: 'Fornecedor criado e vinculado',
      merchantVendorLabel: 'Estabelecimento',
      originalPaymentData: 'Dados de pagamento informados',
      originalMerchantData: 'Estabelecimento informado',
      requestContextTitle: 'Classificação e comprovantes',
      taxId: 'CPF/CNPJ',
      beneficiarySaved: 'Beneficiário atualizado',
      beneficiary: 'Reembolsar para',
      selectEmployeeBeneficiary: 'Selecione o colaborador',
      selectVendorBeneficiary: 'Selecionar fornecedor',
      beneficiaryModeEmployee: 'Colaborador',
      beneficiaryModeVendor: 'Fornecedor',
      vendorBeneficiarySelected: 'Fornecedor selecionado abaixo',
      changeBeneficiary: 'Trocar',
      beneficiaryEmployeeLinked: 'Colaborador vinculado',
      beneficiaryVendorLinked: 'Fornecedor vinculado',
      beneficiaryAutoLinkedHint: 'Vinculado pelo e-mail da solicitação.',
      beneficiaryAutoLinkedHintFull:
        'Identificamos e vinculamos este colaborador pelo e-mail da solicitação. Use Trocar apenas se o pagamento deve ir para outro beneficiário.',
      beneficiaryVendorLinkedHint:
        'Este reembolso será pago ao fornecedor vinculado. Use Trocar para selecionar outro colaborador ou fornecedor.',
      beneficiaryEmployeeHint:
        'Quando o intake identifica o colaborador pelo e-mail, ele é preenchido automaticamente aqui.',
      beneficiaryUnresolvedHint:
        'Não encontramos um colaborador automaticamente. Selecione um colaborador ou fornecedor; se aprovar sem selecionar, criaremos um fornecedor com os dados da solicitação.',
      beneficiaryVendorSelectionHint:
        'Selecione um fornecedor existente. Se deixar em aberto e aprovar, criaremos um fornecedor automaticamente quando houver CPF/CNPJ nos dados da solicitação.',
      beneficiarySelectHint:
        'Selecionar um colaborador ou fornecedor substitui o beneficiário anterior e salva automaticamente.',
      merchantSelectHint: 'Seleção salva automaticamente.',
      merchantSelectHintFull:
        'A seleção é salva automaticamente. Use Trocar apenas se precisar vincular este reembolso a outro estabelecimento.',
      merchantCreating: 'Criando fornecedor e vinculando ao reembolso...',
      merchantVendorLinked: 'Fornecedor vinculado',
      capturedMerchantLabel: 'Informado na solicitação',
      selectMerchantVendor: 'Selecione ou crie o fornecedor',
      attachmentsTitle: 'Anexos',
      attachmentsLoading: 'Carregando anexos…',
      attachmentsEmpty: 'Nenhum anexo encontrado.',
      attachmentsLoadFailed: 'Não foi possível carregar os anexos.',
      viewAttachment: 'Visualizar',
      viewAttachmentInline: 'Ver ao lado',
      viewAttachmentAriaSuffix: 'Visualizar anexo',
      attachmentViewerFailed: 'Não foi possível abrir o arquivo. Tente novamente.',
    },
    transaction: {
      title: 'Revisar transação',
      transaction: 'Transação do cartão',
      apClassificationTitle: 'Classificação',
      managerReviewTitle: 'Revisão do gestor',
      cardDataTitle: 'Dados do cartão',
      aiTitle: 'Sinal automático',
      aiSubtitle:
        'Baseado em MCC, histórico e fornecedor; serve como apoio para a categoria do cartão.',
      apClassificationHelp:
        'Mostra a classificação contábil da transação. Se ainda não houver classificação, abra a conta vinculada para concluir.',
      managerReviewHelp:
        'Registra a revisão do gestor sobre a transação. Ciente e indevida não alteram a classificação contábil.',
      mccHelpLabel: 'O que é MCC?',
      mccHelp:
        'MCC significa Merchant Category Code. É o código da categoria do estabelecimento e ajuda a sugerir a classificação da transação.',
      observation: 'Observação interna',
      observationPlaceholder: 'Anote o racional da classificação...',
      askCardholder: 'Pedir info ao responsável do cartão',
      askCardholderPlaceholder: 'Escreva a pergunta para o titular ou responsável pelo cartão...',
      markImproperTitle: 'Informar motivo da transação indevida',
      markImproperDescription:
        'Registre o motivo para orientar a tratativa. Nenhuma ação de conciliação será executada no sistema.',
      markImproperReason: 'Motivo',
      markImproperReasonPlaceholder: 'Descreva por que esta transação é indevida...',
      annotations: 'Histórico de observações',
      annotationAuthor: 'Autor não informado',
      annotationTypes: {
        observation: 'Observação',
        financeQuestion: 'Pergunta ao responsável',
      },
    },
  },
  actions: {
    review: 'Revisar',
    reject: 'Reprovar',
    askInfo: 'Pedir info',
    acknowledge: 'Ciente',
    approve: 'Aprovar',
    close: 'Fechar',
    askCardholder: 'Pedir info ao responsável',
    improperShort: 'Indevido',
    markImproper: 'Marcar como indevida',
    registerReason: 'Registrar motivo',
    saveObservation: 'Salvar observação',
    manualApprovalSent: 'Reembolso sem política aprovado.',
    policyManualApprovalSent: 'Reembolso aprovado com política.',
    requestMoreInfoSent: 'Pedido enviado por e-mail ao solicitante.',
    convertToBill: 'Gerar fatura AP',
    convertToBillDone: 'Fatura AP gerada.',
    reEvaluatePolicy: 'Reavaliar política',
    policyReevaluated: 'Política reavaliada.',
    policyApplied: 'Política aplicada.',
    reopenForReview: 'Reabrir para revisão',
    reopenedForReview: 'Reembolso reaberto para revisão manual.',
  },
  approvalOrigin: {
    REIMBURSEMENT_POLICY: 'Política',
    BILL_GENERIC_WORKFLOW: 'Workflow AP',
    MANUAL_NO_POLICY: 'Manual',
    AUTO_APPROVE: 'Auto',
    CONVERTED_BILL: 'Conta AP',
  },
  rejectDialog: {
    title: 'Reprovar reembolso',
    description:
      'Informe o motivo da rejeição. Essa mensagem fica registrada no fluxo de aprovação.',
    reasonLabel: 'Motivo',
    placeholder: 'Descreva o motivo da rejeição…',
    confirm: 'Confirmar reprovação',
    cancel: 'Cancelar',
    reasonRequired: 'Informe o motivo da rejeição.',
  },
  approveDialog: {
    title: 'Aprovar reembolso',
    titleBulk: 'Aprovar {{count}} reembolsos',
    description:
      'Tem certeza de que deseja aprovar este reembolso? Uma fatura será gerada automaticamente.',
    descriptionBulk:
      'Tem certeza de que deseja aprovar os {{count}} reembolsos selecionados? Uma fatura será gerada para cada um.',
    commentLabel: 'Justificativa',
    reasonLabel: 'Justificativa',
    placeholder: 'Descreva o motivo da aprovação…',
    confirm: 'Confirmar aprovação',
    cancel: 'Cancelar',
    processingTitle: 'Aprovando reembolso',
    processingDescription: 'Aguarde enquanto concluímos a aprovação.',
    successTitle: 'Reembolso aprovado',
    successDescription: 'A aprovação foi concluída com sucesso.',
    errorTitle: 'Não foi possível aprovar',
    complete: 'Concluir',
    retry: 'Tentar novamente',
    reasonRequired: 'Informe a justificativa da aprovação.',
  },
  reopenForReviewDialog: {
    title: 'Reabrir para revisão manual',
    description:
      'O reembolso voltará para a fila de revisão do gestor, sem aprovar nem reprovar automaticamente. Você poderá aprovar ou reprovar em seguida.',
    commentLabel: 'Observação (opcional)',
    placeholder: 'Descreva por que está reabrindo esta solicitação…',
    confirm: 'Reabrir para revisão',
    cancel: 'Cancelar',
  },
  errors: {
    noPendingStep: 'Não há etapa pendente para o usuário atual',
    noApproversConfigured:
      'Nenhum aprovador foi encontrado para esta política. Configure autoridades de aprovação ou aprovadores antes de aplicar a política.',
    approvalFailed: 'Falha ao aprovar',
    rejectionFailed: 'Falha ao rejeitar',
    reviewSaveFailed: 'Falha ao salvar revisão',
    dueDateSaveFailed: 'Não foi possível salvar a data prevista.',
    approvedAmountSaveFailed: 'Não foi possível salvar o valor aprovado.',
    approvedAmountExceedsRequested:
      'Valor aprovado {{approved}} não pode ser maior que o valor solicitado {{requested}}.',
    merchantSaveFailed: 'Não foi possível salvar o estabelecimento.',
    merchantCreateNeedsTaxId: 'Informe um CNPJ ou CPF válido para criar o fornecedor.',
    merchantCreateFailed: 'Não foi possível criar o fornecedor.',
    beneficiarySaveFailed: 'Não foi possível salvar o beneficiário.',
    beneficiaryAutoCreateFailed:
      'Não foi possível criar o fornecedor automaticamente. Selecione um beneficiário antes de aprovar.',
    requestMoreInfoFailed: 'Não foi possível enviar o pedido de informações.',
    convertToBillFailed: 'Não foi possível gerar a fatura AP.',
    policyReevaluationFailed: 'Não foi possível reavaliar a política.',
    policyApplyFailed: 'Não foi possível aplicar a política.',
    reopenForReviewFailed: 'Não foi possível reabrir o reembolso para revisão.',
    requestMoreInfoMessageRequired: 'Escreva a mensagem que será enviada ao solicitante.',
    forbidden:
      'Você não tem permissão para realizar esta ação. Peça ao administrador para conceder o acesso necessário.',
    unauthorized: 'Sua sessão expirou. Faça login novamente.',
  },
};

export const managerDashboardEn = {
  header: {
    title: 'Manager dashboard',
    subtitle: 'Reimbursements for the areas you lead.',
    subtitleReimbursements:
      'Track reimbursements for the areas you lead — prioritizing approvals, reviews, and period history.',
    subtitleCreditCards:
      'Consolidated view of statements for all cards — organized by institution and card, without losing context while navigating.',
    subtitleAreaAccounts:
      'Track recurring and on-demand area bills — organized by origin, due date, and managerial classification.',
    subtitleContractOnly: 'Contracts in your area or tagged to you.',
    newReimbursement: 'New reimbursement',
    export: 'Export',
  },
  reimbursementLinks: {
    title: 'New reimbursement',
    description: 'Choose how to start a reimbursement request.',
    publicLinks: 'Available links',
    noPublicLinks: 'There are no public reimbursement links available.',
    loading: 'Loading reimbursement links…',
    open: 'Open',
    openInNewTab: 'Open in new tab',
    loadError: 'Could not load reimbursement links.',
  },
  reimbursementDetails: {
    back: 'Back',
    backToBill: 'Back to bill',
    backToDocuments: 'Back to documents',
    backToDashboard: 'Back to dashboard',
    permissionDeniedTitle: 'No permission to view this reimbursement',
    permissionDenied:
      "You don't have permission to access this request. Ask your administrator to grant access.",
    notFoundTitle: 'Reimbursement not found',
    notFound: 'This request does not exist or was removed.',
    breadcrumb: 'Reimbursement',
    pageTitle: 'Reimbursement - {{name}} - {{amount}}',
    documentTitle: 'Reimbursement: {{name}}',
    resizePanelsAria: 'Resize receipt and review panels',
  },
  common: {
    recurring: 'Recurring',
    onDemand: 'On-demand',
    notAvailable: 'Not available',
  },
  filters: {
    competency: 'Competency',
    registrationMonth: 'Created',
    previousMonth: 'Previous competency',
    currentMonth: 'Selected competency',
    nextMonth: 'Next competency',
    scope: 'Scope',
    scopeReimbursements: 'Reimbursement scope',
    scopeCreditCards: 'Card scope',
    scopeAreaAccounts: 'Area bills scope',
    scopeTitle: 'Filter by scope',
    scopeHint: 'Selected departments and cost centers are combined by any matching relationship.',
    scopeReimbursementsTitle: 'Reimbursement scope',
    scopeReimbursementsHint: 'Shows requests linked to any selected department or cost center.',
    scopeCreditCardsTitle: 'Card scope',
    scopeCreditCardsHint:
      "Shows cards linked to the card itself or to the holder's current area in any selected scope.",
    scopeAreaAccountsTitle: 'Area bills scope',
    scopeAreaAccountsHint:
      'Shows bills whose AP classification contains any selected department or cost center.',
    scopeNoneSelected:
      'No filter selected. With no selection, the view shows the full permitted scope.',
    scopeNoDepartments: 'No departments available for this scope.',
    scopeNoCostCenters: 'No cost centers available for this scope.',
    scopeClear: 'Clear',
    scopeApply: 'Apply',
    departments: 'Departments',
    costCenters: 'Cost centers',
  },
  kpis: {
    label: 'Manager KPIs',
    pendingApproval: { title: 'Awaiting approval' },
    awaitingYou: { title: 'Waiting for you' },
    reimbursementTotal: { title: 'Period total' },
    reimbursementRejected: { title: 'Rejected' },
    reimbursementApproved: { title: 'Approved' },
    areaSpend: { title: 'Area spend this month' },
    invoices: {
      title: 'Cards to review',
      detail: '3 cards in your area',
    },
    trend: { title: 'Vs previous month' },
    pendingCount: '{{count}} pending',
    cardCount: '{{count}} cards',
    invoicesAwaitingReview: '{{count}} cards awaiting review',
    invoicesDueSoon: '{{count}} cards due within 7 days',
    liveData: 'Real-time data',
    trendLoading: 'Comparing to the previous month…',
    trendNoActivity: 'No reimbursements in this scope for this month or the previous one',
    trendNewBaseline: 'No postings in {{month}} to compare',
    trendUnchanged: 'Same as {{month}}',
    trendAbove: '{{amount}} above {{month}}',
    trendBelow: '{{amount}} below {{month}}',
    trendMixedCurrency:
      'Totals in different currencies are left out of the comparison with the previous month',
  },
  tabs: {
    reimbursements: 'Reimbursements',
    creditCards: 'Credit cards',
    areaAccounts: 'Area bills',
  },
  contractReviews: {
    title: 'Contract reviews',
    subtitle: 'Contracts in your area or tagged to you (reviewer, owner, or approval).',
    count: '{{count}} contract(s)',
    loading: 'Loading contracts…',
    loadError: 'Could not load contracts.',
    empty: 'No contracts in your area or tagged to you.',
    open: 'Open review',
    relevance: {
      PRIMARY_REVIEWER: 'Reviewer',
      RESPONSIBLE: 'Owner',
      PENDING_APPROVAL: 'Approval pending',
      AREA_OWNER: 'Your area',
    },
  },
  reimbursements: {
    loading: 'Loading reimbursements…',
    request: 'Request',
    all: 'All',
    unreviewed: 'Not reviewed',
    review: 'In review',
    approved: 'Approved',
    rejected: 'Rejected',
    pending: 'Pending',
    mine: 'Approvals for me',
    history: 'History',
    requester: 'Requester',
    description: 'Description',
    policy: 'Policy',
    costCenter: 'Cost center',
    date: 'Date',
    amount: 'Amount',
    listAmountRequested: 'Requested {{amount}}',
    listAmountProposed: 'Approval {{amount}}',
    reason: 'Status',
    statusColumn: 'Status',
    billReference: 'AP bill',
    origin: 'Origin',
    comment: 'Comment',
    rejectionReasonColumn: 'Rejection reason / approval comment',
    rejectionReasonMissing: 'Reason not recorded',
    emDash: '—',
    openHistoryDetailsAria: 'Open reimbursement details: {{description}}',
    actions: 'Actions',
    registeredAt: 'Created',
    dueDate: 'Due date',
    dueDateShort: 'Due {{date}}',
    supplier: 'Supplier',
    supplierNotIndicated: 'Merchant not provided',
    classification: 'Classification',
    aiColumn: 'Alerts',
    dates: 'Dates',
    activeFilters: 'Active filters',
    clearAllFilters: 'Clear all',
    aiColumnTooltip:
      'Alerts for this reimbursement: auto-approved, OK, attention, or risk. Hover a badge to see the detail.',
    pagination: {
      empty: 'No requests found',
      range: '{{start}}–{{end}} of {{total}} requests',
    },
    bulkInstruction: 'Select reimbursements actionable by you to approve or reject in bulk.',
    bulkSelected: '{{count}} selected',
    bulkApprove: 'Approve selected',
    bulkReject: 'Reject selected',
    bulkRejectDisabled: 'Use row "Reject" to provide a reason for each request.',
    summaryPending: '{{count}} requests · {{amount}}',
    summaryMine: '{{count}} approvals for me',
    summaryHistory: '{{count}} reviewed items · AP bridge generated',
    summaryAll: '{{count}} requests · {{amount}}',
    summaryUnreviewed: '{{count}} not reviewed · {{amount}}',
    summaryReview: '{{count}} in review · {{actionable}} for you',
    summaryApproved: '{{count}} approved · {{amount}}',
    summaryRejected: '{{count}} rejected · {{amount}}',
    classificationCostCenter: 'Cost center: {{value}}',
    classificationDepartment: 'Dept: {{value}}',
    sortFilterHint: 'Sort and filter',
    sortByColumn: 'Sort by {{column}}',
    filterByColumn: 'Filter {{column}}',
    filterContainsPlaceholder: 'Search…',
    filterAmountMin: 'Minimum amount',
    filterAmountMax: 'Maximum amount',
    filterApply: 'Apply',
    filterClear: 'Clear',
    dueRelative: {
      today: 'due today',
      inDays: 'in {{count}} days',
      overdue: '{{count}}d overdue',
    },
    ai: {
      ok: 'OK',
      attention: 'Attention — {{count}}',
      risks: 'Risks — {{count}}',
      autoApproved: 'Auto-approved',
      noFindings: 'No findings',
      detailsTitle: 'Alquim AI signals',
    },
    aiShort: {
      ai: 'AI',
      classification: 'Classification',
      deadline: 'Deadline',
      limit: 'Limit',
      policy: 'Policy',
      receipt: 'Receipt',
      taxId: 'Tax ID',
      beneficiary: 'Beneficiary',
      amount: 'Amount',
      withExtra: '{{label}} +{{count}}',
    },
    aiDetails: {
      documentReuseWarning: 'Receipt was already used in another request',
      duplicateDocumentAlreadyApproved:
        'Receipt already approved on another reimbursement or bill — automatically rejected',
      policyBlocker: 'Policy review required',
      policyDecisionAlert: '{{message}}',
      weakPolicyMatch: 'Policy suggestion has low confidence',
      ambiguousPolicyMatch: 'More than one policy may apply',
      parseFallback: 'AI did not return a reliable structured response',
      lowClassificationConfidence: 'Classification has low confidence',
      receiptTotalExceedsRequested:
        'Receipt total is higher than the amount requested for reimbursement',
      requesterNameMissingOnReceipt:
        'Receipt does not clearly show the beneficiary (requester) name',
      requesterNameMismatchOnReceipt:
        'Name on the receipt does not match the requester on this request',
    },
    supplierHints: {
      newVendor: 'New vendor',
      recurring: 'recurring bill',
    },
    table: {
      policy: 'Policy',
    },
    roles: {
      employee: 'Employee',
      vendor: 'Vendor',
      external: 'External',
    },
    fallback: {
      requester: 'Requester',
      description: 'Reimbursement',
      policy: 'Policy pending',
      noPolicy: 'No policy',
      costCenterSelected: 'Cost center selected',
      departmentSelected: 'Department selected',
      policyValidation: 'Awaiting policy approval',
      justification: 'No justification provided',
      attachments: '{{count}} attachments',
      standaloneRequest: 'Standalone request',
      billReference: 'Bill {{billId}}',
    },
    flags: {
      autoApproved: 'Automatically approved',
      aiApprovedWithCaveat: 'Approved by AI with caveat',
      aiPolicyManualReview: 'Manual review required by AI',
      exceedsPeriodLimit: 'Exceeds period limit',
      exceedsTransactionLimit: 'Exceeds per-transaction limit',
      lateSubmission: 'Expense outside policy deadline',
      nearPeriodLimit: 'Period limit almost reached',
      noPolicyMatched: 'No matching policy identified',
      policyOverride: 'Policy adjusted manually',
      taxIdEntityMissingOnDocument: 'Document missing company tax ID',
    },
    empty: {
      title: 'No reimbursements found',
      pendingDescription:
        'Requests waiting for review will appear here. If the list stays empty, configure reimbursement policies and approval workflows.',
      historyDescription: 'Approved or rejected reimbursements will appear here after review.',
    },
    loadErrorTitle: 'Could not load reimbursements',
    loadError: 'Try again in a moment or check your connection.',
    permissionDeniedTitle: 'No permission to view reimbursements',
    permissionDenied:
      "You don't have permission to access reimbursements in this scope. Ask your administrator to grant access.",
    timeline: {
      requestCreated: 'Request created',
      linkedToBill: 'Linked to AP bill',
      standaloneCreated: 'Created without AP bill',
      rejectionRecorded: 'Rejection recorded',
      rejectionReason: 'Reason: {{reason}}',
      rejectionReasonMissing: 'No reason provided.',
      rejectionRecordedBy: 'Recorded by {{name}}',
      requestMoreInfoRecorded: 'Information request recorded',
      requestMoreInfoMessage: 'Message: {{message}}',
      requestMoreInfoMessageMissing: 'Message text not available in history.',
      infoResponseRecorded: 'Requester response recorded',
      infoResponseMessage: 'Response: {{message}}',
      infoResponseFields: 'Updated fields: {{fields}}',
      infoResponseAttachments: '{{count}} attachment(s) received',
      infoResponseNoDetail: 'Response received with no additional details.',
      approvalFinalRecorded: 'Final approval recorded',
      approvalManualRecorded: 'Manual approval recorded',
      approvalStepTitle: 'Approval step',
      approvalStepRecorded: 'Step {{stepNumber}} — {{stepName}}',
      approvalCommentLine: 'Comment: {{comment}}',
      approvalAmountLine: 'Approved amount: {{amount}}',
      approvalNoExtraDetail: 'Approval recorded with no additional comment.',
      billConversionRecorded: 'Converted to AP bill',
      documentReuseRecorded: 'Receipt reused',
      documentReuseLine: '{{documentName}} was already used in another request: {{requestIds}}',
      reviewDetailsUpdated: 'Reimbursement details updated',
      reviewUpdateSummaryFallback: 'Detail changes were saved.',
      reviewLineMerchantName: 'Merchant: {{value}}',
      reviewLineMerchantTaxId: 'Tax ID: {{value}}',
      reviewLineMerchantVendorId: 'Vendor (ID): {{value}}',
      reviewLineTags: 'Tags: {{value}}',
      reviewLineDueDate: 'Expected reimbursement date: {{value}}',
      reviewLineReviewerApprovedAmount: 'Approved amount (review): {{amount}}',
      reviewLineDepartment: 'Department: {{value}}',
      reviewLineCostCenter: 'Cost center: {{value}}',
      reviewLineSegments: 'Classification: {{value}}',
      reviewLineCustomFields: 'Custom fields: {{value}}',
    },
    status: {
      managerApproval: 'Your approval',
      overdueShort: '3d overdue',
      autoApprovable: 'Approved',
      awaitingInfo: 'Awaiting requester',
      infoReceivedAwaitingManager: 'Manager · info received',
      awaitingManagerTriage: 'Manager · triage (no policy)',
      awaitingManagerReview: 'Manager · awaiting review',
      systemAiPolicyReview: 'AI · policy review',
      workflowAwaitingApprovers: 'Workflow · another approver',
      workflowAwaitingYou: 'Workflow · your step',
      systemBillWorkflow: 'System · AP workflow',
      autoApprovedBySystem: 'System · auto-approved',
      approvedByManager: 'Manager · approved',
      convertedToBill: 'AP bill created',
      rejected: 'Rejected',
      actionableByCurrentUser: 'Your action',
      noPolicyPendingReview: 'Manager · triage (no policy)',
      policyPendingApproval: 'In review',
      billWorkflowFallback: 'System · AP workflow',
      autoApproved: 'System · auto-approved',
      policyApproved: 'Approved',
      infoReceived: 'Manager · info received',
    },
  },
  status: {
    managerApproval: 'Your approval',
    overdueDays: '{{count}}d overdue',
    autoApprovable: 'Approved',
  },
  historyStatus: {
    approved: 'Approved',
    rejected: 'Rejected',
  },
  creditCards: {
    title: 'Area cards',
    subtitle: 'Select a card to review the statement.',
    subtitleWithReviewCount: '{{count}} of {{total}} cards awaiting review.',
    activeCount: '{{count}} active cards',
    searchPlaceholder: 'Search by institution, card, or holder...',
    searchEmpty: 'No cards found for this search.',
    openInvoice: 'Open statement',
    closedInvoice: 'Closed statement',
    limit: 'Limit',
    available: 'Available',
    noPeriodStatement: 'No statement in period',
    emptyScopeTitle: 'No cards in this scope',
    emptyScopeDescription:
      "Adjust departments or cost centers to see cards linked to the card itself or to the holder's current area.",
    invoiceBadge: {
      open: 'Open',
      closed: 'Closed',
      paid: 'Paid',
      reviewed: 'Reviewed',
      active: 'Active',
      inactive: 'Inactive',
    },
    cardBadge: {
      reviewed: 'Card reviewed',
      pending: 'Card awaiting review',
    },
    navigation: {
      overview: 'Overview',
      institutions: 'Institutions',
      footer: '{{institutions}} institutions · {{cards}} active cards',
    },
    overview: {
      title: 'Institutions and cards',
      subtitle: 'Track pending reviews, limits, and open statements before drilling into details.',
      summary: '{{institutions}} institutions · {{cards}} active cards',
      byInstitution: 'By institution',
      byInstitutionHint: '— click to view each institution’s cards',
      pendingBadge: '{{count}} pending',
      openTotal: 'total in open statements',
      activeCards: '{{count}} active cards',
      limitPercent: '{{percent}} of limit',
    },
    institution: {
      subtitle: 'Active cards from this institution in the selected period.',
      summary: '{{cards}} active cards · {{pending}} pending',
    },
    card: {
      cardSubtitle: '{{brand}} card',
      summary: '{{amount}} open · {{limit}} limit',
    },
    metrics: {
      totalOpen: 'Total in open statements',
      totalLimit: 'Total limit',
      activeCards: 'Active cards',
      reviewedStatements: 'Reviewed statements',
      reviewedCards: 'Reviewed cards',
      pendingReview: 'Pending review',
      cardsAndInstitutions: '{{cards}} cards · {{institutions}} institutions',
      activeCardsDetail: '{{count}} active cards',
      utilized: '{{percent}} used in period',
      institutions: 'Distributed across {{count}} institutions',
      awaitingAction: '{{count}} awaiting action',
      pendingAmount: '{{amount}} in pending transactions',
    },
    insights: {
      periodTitle: 'Period insights',
      institutionTitle: 'Institution insights',
      total: 'Period total',
      totalDetail: 'Consolidated open statements',
      topInstitution: 'Institution with highest volume',
      topCard: 'Card with highest statement',
      pendingReview: 'Pending review',
      pendingAmount: '{{amount}} in pending transactions',
      openAmount: '{{amount}} in open statements',
      noData: 'No data in period',
      newCards: 'New cards in period',
      newCardsDetail: 'No new card identified in this period.',
      overThirty: 'Usage above 30%',
      overThirtyDetail: 'Based on the limit utilization percentage in the period.',
      none: 'None',
    },
    table: {
      allCardsTitle: 'All cards',
      sortedByOpenInvoice: '— sorted by open statement',
      institutionCardsTitle: 'Cards',
      clickCardHint: '— click a card to view the statement',
      institution: 'Institution',
      card: 'Card',
      lastFour: 'Last four',
      openInvoice: 'Open statement',
      limit: 'Limit',
      status: 'Status',
    },
    statementNavigation: {
      previous: 'Previous statement',
      next: 'Next statement',
    },
    statementSelector: {
      label: 'Statement',
      placeholder: 'Select a statement for the period',
    },
    statementHeader: {
      title: 'Selected statement',
      period: 'Period {{period}}',
      closing: 'Closing',
      due: 'Due',
      transactions: 'Transactions',
      vendors: 'Vendors',
      transactionCount: '{{count}} transactions',
      vendorCount: '{{count}} vendors',
      status: {
        open: 'Open',
        closed: 'Closed',
        paid: 'Paid',
        reviewed: 'Reviewed',
        cardReviewed: 'Card reviewed',
      },
    },
    reviewBannerTitle: 'Closed statement — awaiting your review',
    reviewBannerOpenTitle: 'Open statement — awaiting your review',
    reviewedBannerTitle: 'Statement reviewed',
    reviewDueDate: 'Due {{date}}',
    markReviewedButton: 'Mark as reviewed',
    reviewedButton: 'Reviewed',
    cardReviewBannerTitle: 'Card awaiting review',
    cardReviewBannerOpenTitle: 'Card awaiting review',
    cardReviewedBannerTitle: 'Card reviewed',
    invoiceReviewedBannerTitle: 'Invoice reviewed',
    markCardReviewedButton: 'Mark card as reviewed',
    undoCardReviewButton: 'Undo card review',
    invoiceReviewProgress: '{{reviewed}} of {{total}} cards reviewed',
    unresolvedInvoiceTransactions: '{{count}} transactions without an identifiable card',
    loading: 'Loading real statement and transactions…',
    loadError: 'Could not load real card data.',
    emptyCardsTitle: 'No corporate cards found',
    emptyCardsDescription:
      'Create cards under Operations > Credit cards or connect an integration to track real statements here.',
    emptyStatementTitle: 'No statement found for this card',
    emptyStatementDescription:
      'Import or sync the card statement to unlock transactions, insights, and persisted review.',
    reviewSaved: 'Statement marked as reviewed.',
    reviewSaveFailed: 'Could not mark the statement as reviewed.',
    cardReviewSaved: 'Card marked as reviewed.',
    cardReviewReverted: 'Card review undone.',
    observationSaved: 'Observation saved on the transaction.',
    cardItemApproved: 'Transaction marked as acknowledged.',
    acknowledgedAnnotationContent: 'Transaction marked as acknowledged by the manager.',
    improperReasonSaved: 'Reason registered on the transaction.',
    improperReasonAnnotationContent:
      'Transaction marked as improper by the manager. Reason: {{reason}}',
    cardholderQuestionSaved: 'Question registered for the card owner.',
    annotationSaveFailed: 'Could not save the annotation.',
    cardItemIgnored: 'Transaction marked as improper.',
    cardItemIgnoreFailed: 'Could not mark the transaction as improper.',
    comparison: {
      currentTitle: '{{date}} (this period)',
      currentSubtitle: '{{transactions}} transactions · {{vendors}} vendors',
      previousTitle: '{{date}}',
      previousSubtitle: '{{transactions}} transactions · {{vendors}} vendors',
      noPreviousTitle: 'No previous statement',
      noPreviousSubtitle: 'Import previous periods to compare',
      empty: 'No categorized transactions to compare.',
    },
    transactions: {
      title: 'Statement transactions',
      helper: '{{count}} transactions · click to review details',
      empty: 'No transactions found in this statement.',
      loadMore: 'Load more transactions',
      loadingMore: 'Loading…',
      columns: {
        date: 'Date',
        merchant: 'Merchant',
        apClassification: 'Classification',
        accounting: 'Accounts',
        organization: 'Cost center/Dept.',
        categorization: 'Category',
        installment: 'Installment',
        reviewStatus: 'Review',
        amount: 'Amount',
        action: 'Action',
      },
      apClassification: {
        classified: 'Classification',
        imported: 'Classification pending',
        reconciledWithAp: 'Reconciled with AP',
        pendingBillClassification: 'Classification pending',
        reconciled: 'Reconciled',
        uncategorized: 'No AP classification',
        infoRequested: 'Awaiting information',
        improper: 'Improper',
        categoryHint: 'Card category: {{category}}',
        openLinkedBill: 'Open bill {{billId}}',
        linkedBillVendor: 'Vendor: {{vendor}}',
      },
      reviewStatus: {
        pending: 'Pending',
        acknowledged: 'Aware',
        improper: 'Improper',
      },
    },
  },
  cards: {
    insights: {
      title: 'Statement insights',
      newVendors: 'New vendors',
      increasedVendors: 'Increased more than 30%',
    },
  },
  areaAccounts: {
    title: 'Area bills · January 2026',
    subtitle: 'Recurring and on-demand bills with spend origin.',
    summary: '{{count}} bills · {{amount}}',
    metrics: {
      total: 'Total bills',
      totalDetail: '{{count}} bills in the period',
      recurring: 'Recurring',
      recurringDetail: '{{count}} recurring bills',
      onDemand: 'On-demand',
      onDemandDetail: '{{count}} on-demand bills',
      average: 'Average ticket',
      averageDetail: 'Average per bill in the period',
    },
    recurringHeading: 'Recurring — {{amount}} (64% of spend)',
    onDemandHeading: 'On-demand — {{amount}} (36% of spend)',
    table: {
      vendor: 'Vendor',
      description: 'Description',
      managerialAccount: 'Managerial account',
      dueDate: 'Due date',
      status: 'Status',
      origin: 'Origin',
      vsDecember: 'Vs Dec',
      amount: 'Amount',
    },
    status: {
      paid: 'Paid',
      scheduled: 'Scheduled',
      inApproval: 'In approval',
    },
    origin: {
      manual: 'Manual',
      card: 'Card',
      reimbursement: 'Reimbursement',
    },
    fallback: {
      vendor: 'Bill',
      description: 'Area bill',
      reimbursementAccount: 'Reimbursement',
      expenseAccount: 'Expense',
    },
  },
  tables: {
    category: 'Category',
  },
  drawers: {
    reimbursement: {
      title: 'Review reimbursement',
      description: 'Policy validation, receipt, and audit timeline.',
      detailTitle: 'Reimbursement details',
      detailDescription: 'Policy validation, receipt, and audit history.',
      noPendingAction: 'No step is pending your approval.',
      rejectedReadOnlyFooter:
        'This request was already rejected. Approval actions are not available here anymore.',
      rejectedChainCannotReopen:
        'This request was rejected through a formal approval step and cannot be reopened here; ask an approver to start a new approval instead.',
      amount: 'Requested amount',
      approvedAmount: 'Approved amount',
      approvedAmountHint: 'Max. requested amount.',
      approvedAmountHintFull:
        'Amount effectively approved for reimbursement. It cannot exceed the requested amount.',
      approvedAmountReadOnly: 'Cannot be changed after converting to an AP bill.',
      validationDecisionTitle: 'Your decision',
      policyFrameTitle: 'Policy',
      accountingClassificationTitle: 'Accounting classification',
      viewPolicy: 'View policy',
      viewPolicyAria: 'Open policy {{name}} in a new tab',
      viewPolicyDescription: 'View policy description',
      policyDescriptionSection: 'Description',
      policyAiTextSection: 'Policy rules (AI)',
      policyJustificationSection: 'Justification instructions',
      policyNoDescription: 'This policy has no description on file.',
      linkedApBillLabel: 'Linked AP bill',
      linkedBillSentToAp: 'Reimbursement approved and sent to the AP bill flow.',
      linkedBillPendingApFinalization:
        'Reimbursement approved. The bill is pending in the AP/accounting flow for validation, final approval, GL accrual, and payment.',
      linkedBillLink: 'Open bill {{billId}}',
      linkedBillLinkAria: 'Open AP bill {{billId}}',
      contactPayment: 'Contact & payment',
      requesterLabel: 'Requester',
      merchantLabel: 'Merchant',
      merchantTaxIdLabel: 'Merchant tax ID',
      expenseCategoryLabel: 'Category',
      receiptMethodLabel: 'Payment receipt',
      requesterEmail: 'Requester email',
      pixKey: 'Pix key',
      payoutMethod: 'Payment method',
      payoutDetails: 'Payment details',
      submittedAt: 'Request submitted',
      reimbursementDueDateLabel: 'Expected reimbursement date',
      reimbursementDueDateHint: 'Expected payment date.',
      reimbursementDueDateHintFull: 'Expected date to reimburse the approved beneficiary.',
      reimbursementDueDateReadOnly: 'Cannot be changed after converting to an AP bill.',
      datesSectionTitle: 'Dates',
      notProvided: 'Not provided',
      validation: 'Policy validation',
      policyApprovalTitle: 'Policy and approval',
      policyAppliedBadge: 'Applied',
      policyMissingBadge: 'No policy',
      policyResultLabel: 'Result',
      policyResultNoPolicy: 'No policy applied',
      approverConfigurationIssueTitle: 'No approver configured',
      approverConfigurationIssueDescription:
        'This policy requires approval, but the step has no assigned users. Configure approval authorities or policy approvers to unblock this reimbursement.',
      policyDecisionTitle: 'Policy decision',
      viewWhyAnalysisStopped: 'See why the analysis stopped',
      unknownPolicyBlocker: 'The policy analysis requires review.',
      pendingPolicyMismatchTitle: 'The applied policy does not match the expense',
      pendingPolicyMismatchDescription:
        'Change the policy so the analysis uses the correct rules for this request.',
      pendingManualReviewTitle: 'The automated analysis requires your review',
      pendingManualReviewDescription:
        'Check the evidence before deciding; this signal does not prevent a justified approval.',
      pendingDependentInformationTitle: 'Dependent evaluation data is missing',
      pendingDependentInformationDescription:
        'The policy depends on beneficiary information that was not identified in the request.',
      pendingGenericPolicyDescription: 'Review this condition before approving the reimbursement.',
      pendingPolicyMissingTitle: 'No policy has been applied',
      pendingPolicyMissingDescription: 'Select the appropriate policy to evaluate this expense.',
      pendingBeneficiaryTitle: 'Reimbursement beneficiary is not defined',
      pendingBeneficiaryDescription: 'Select the employee or vendor who will receive the payment.',
      pendingMerchantTitle: 'Vendor is not linked in the ERP',
      pendingMerchantDescription: 'Link the establishment so the payable can be created.',
      pendingClassificationTitle: 'Accounting classification is incomplete',
      pendingClassificationDescription:
        'Complete the required classification fields before approving.',
      decisionPendingItemsOne: '1 pending item before approval',
      decisionPendingItemsOther: '{{count}} pending items before approval',
      approveWithPendingOne: 'Approve with 1 pending item',
      approveWithPendingOther: 'Approve with {{count}} pending items',
      policyDecision: {
        APPROVE_AUTOMATICALLY: 'Auto-approve',
        REQUEST_APPROVAL: 'Request approval',
        REQUEST_MORE_INFO: 'Request more info',
        ALERT_ONLY: 'Alert only',
        MANUAL_REVIEW: 'Manual review',
        REJECT_AUTOMATICALLY: 'Reject automatically',
      },
      policyDecisionReason: {
        MANUAL_REVIEW: 'Automatic evaluation failed; manual review is required.',
      },
      policyDecisionAlert: {
        AI_PARSE_FALLBACK:
          'AI policy output was invalid or unavailable; manual review is required.',
        AI_LOW_CONFIDENCE: 'AI policy confidence is below the automatic approval threshold.',
        AI_REQUESTED_MANUAL_REVIEW: 'AI policy evaluation requested manual review.',
        POLICY_CATEGORY_MISMATCH:
          'The AI policy category does not match the reimbursement category.',
        AI_APPROVAL_WITH_CAVEAT: 'AI approved with caveats; manager review is required by default.',
        AI_DEPENDENT_EVALUATION_MISSING:
          'The policy mentions dependents, but AI did not return dependent evaluation.',
        DEPENDENT_REQUESTER_NOT_EMPLOYEE:
          'Dependent policy evaluation requires the requester to be linked to an employee.',
        DEPENDENT_DATA_NOT_FOUND: 'No active dependents were found for the employee requester.',
        DEPENDENT_INFORMATION_MISSING:
          'Required information is missing for dependent rule validation.',
        DEPENDENT_MATCH_MISSING:
          'No dependent was clearly identified in the reimbursement request.',
        DEPENDENT_MATCH_INVALID: 'AI matched dependents that are not present in the HCM context.',
        DEPENDENT_BIRTH_DATE_MISSING:
          'A matched dependent is missing birth date for age-band validation.',
        DEPENDENT_LIMIT_MISSING:
          'Dependent amount rules require a calculated limit for automatic approval.',
        DEPENDENT_LIMIT_EXCEEDED:
          'Requested amount exceeds the limit calculated from dependent rules.',
        DOCUMENT_REUSE_WARNING:
          'One or more reimbursement documents were reused from a previous request.',
        DUPLICATE_DOCUMENT_ALREADY_APPROVED:
          'The receipt was already used on an approved reimbursement or settled AP bill; the request was automatically rejected to prevent duplicate payment.',
        AI_POLICY_REJECTED:
          'The policy evaluated this request as outside the rules and rejected it automatically.',
        AI_SELECTED_FROM_AMBIGUOUS_POLICIES:
          'More than one policy could apply; AI selected the most coherent one and kept it for manual review.',
        AI_REJECTION_REQUIRES_REVIEW:
          'AI rejection is advisory until an explicit automatic rejection policy exists.',
      },
      dependentEvaluationTitle: 'Dependent evaluation',
      dependentEvaluationMatchedCount: '{{count}} dependent(s)',
      dependentEvaluationLimit: 'Calculated limit',
      dependentEvaluationCriteria: 'Criteria',
      policyExcessAmount: 'Excess',
      policyNoExcess: 'Within limit',
      approvalChainDetailsTitle: 'View full chain',
      noPolicyWarning:
        'No compatible policy was identified. Select a policy to resubmit this request to approval.',
      policySuggestionTitle: 'Suggested policy',
      policySuggestionManualReviewHint:
        'The policy can be applied, but evaluation indicates manual review (e.g. amount band).',
      applySuggestedPolicy: 'Apply suggestion',
      policySuggestionReason: {
        POLICY_SUGGEST_CATEGORY_ID_MATCH: 'Request category matches the policy category.',
        POLICY_SUGGEST_CATEGORY_LABEL_MATCH: 'Category label matches the policy.',
        POLICY_SUGGEST_CATEGORY_LABEL_PARTIAL: 'Category partially aligns with the policy label.',
        POLICY_SUGGEST_AI_CATEGORY_GATE: 'Category fits the AI policy gate.',
        POLICY_SUGGEST_AI_CATEGORY_WEAK: 'Weak category match for the AI policy.',
        POLICY_SUGGEST_WORKFLOW_MATCH: 'Policy workflow conditions matched.',
        POLICY_SUGGEST_AI_APPROVED: 'AI indicated automatic approval.',
        POLICY_SUGGEST_AI_APPROVED_WITH_RESERVATION:
          'AI approved with reservations — manual review likely.',
        POLICY_SUGGEST_AI_MANUAL_REVIEW: 'AI requested manual review.',
        POLICY_SUGGEST_AI_REJECTED: 'AI indicated rejection.',
      },
      policySuggestionUnknownReason: 'The policy was suggested by the automated analysis.',
      requestedAmount: 'Requested amount',
      effectivePolicyLimit: 'Effective limit',
      policyUsedInPeriod: 'Used in period',
      policyRemainingMargin: 'Remaining margin',
      selectPolicy: 'Select policy',
      policyAutoApplyHint: 'The policy is applied automatically when selected.',
      clearPolicySelection: 'No policy',
      applyPolicy: 'Apply policy',
      changePolicy: 'Change policy',
      allowLimitOverrideLabel: 'Allow amount above policy limit (recorded on the limit evaluation)',
      allowLimitOverrideHint:
        'Use only when the manager proposal exceeds the effective cap; the request remains auditable in history and metadata.',
      limitOverrideRecorded:
        'Policy limit was explicitly exceeded in the latest evaluation (override recorded).',
      policyOverrideComment: 'Comment about the policy change...',
      approvalChainTitle: 'Approval chain',
      approvalChainStatus: 'Chain status: {{status}}',
      approvalStepLabel: 'Step {{number}} — {{name}}',
      approvalNoApprovers: 'No approvers resolved',
      justification: 'Justification',
      receipt: 'Receipt',
      timeline: 'Timeline',
      expenseDetailsTitle: 'Expense',
      historyTitle: 'History',
      askInfo: 'Message to requester',
      askInfoHelper:
        'Use this message to ask for information or explain a rejection. For approval, the comment is optional.',
      askInfoPlaceholder: 'Write what is missing before approval or the rejection reason...',
      askInfoHistory: 'Message history to requester',
      askInfoHistoryEmpty: 'No messages have been sent to the requester yet.',
      askInfoHistoryRoleManager: 'Manager',
      askInfoHistoryRoleRequester: 'Requester',
      tabInformation: 'Information',
      tabValidation: 'Validation',
      tabRequest: 'Request',
      tabClassification: 'Classification',
      tabTimeline: 'Timeline',
      tabStateOk: 'OK',
      tabStatePending: 'Pending',
      tabStateAction: 'Action',
      requestReadOnlyFooter: 'Read-only tab. Use Validation to interact with the reimbursement.',
      reviewFields: 'Review classification',
      aiSuggestedClassification: 'Automatic suggestion',
      reviewTags: 'Tags',
      reviewTagsPlaceholder: 'New tag',
      reviewTagsHint: 'Type the text and press Enter or comma to add.',
      reviewTagsRemoveAria: 'Remove tag',
      reviewCategory: 'Category',
      reviewCategoryPlaceholder: 'e.g. Software and Technology',
      expenseCategoryVsApHint:
        'The category chosen by the requester guides policies and intake. AP classification (department, cost center, etc.) is set on the Classification tab and flows to the AP bill.',
      reviewDepartment: 'Department',
      reviewDepartmentPlaceholder: 'Select a department',
      reviewCostCenter: 'Cost center',
      reviewCostCenterPlaceholder: 'Select a cost center',
      reviewGlAccount: 'GL account',
      reviewGlAccountPlaceholder: 'Select a GL account',
      reviewManagerialAccount: 'Managerial account',
      reviewManagerialAccountPlaceholder: 'Select a managerial account',
      reviewCustomFieldsTitle: 'Custom fields',
      reviewCustomFieldsHint: 'Additional classification segments (same as on the AP bill).',
      saveReview: 'Save review',
      reviewSaved: 'Review saved',
      dueDateSaved: 'Expected date updated',
      approvedAmountSaved: 'Approved amount updated',
      merchantSaved: 'Establishment updated',
      merchantCreated: 'Vendor created and linked',
      merchantVendorLabel: 'Merchant',
      originalPaymentData: 'Submitted payment data',
      originalMerchantData: 'Submitted merchant',
      requestContextTitle: 'Classification and receipts',
      taxId: 'Tax ID',
      beneficiarySaved: 'Beneficiary updated',
      beneficiary: 'Reimburse to',
      selectEmployeeBeneficiary: 'Select the employee',
      selectVendorBeneficiary: 'Select vendor',
      beneficiaryModeEmployee: 'Employee',
      beneficiaryModeVendor: 'Vendor',
      vendorBeneficiarySelected: 'Vendor selected below',
      changeBeneficiary: 'Change',
      beneficiaryEmployeeLinked: 'Employee linked',
      beneficiaryVendorLinked: 'Vendor linked',
      beneficiaryAutoLinkedHint: 'Linked from the request email.',
      beneficiaryAutoLinkedHintFull:
        'We identified and linked this employee from the request email. Use Change only if payment should go to another beneficiary.',
      beneficiaryVendorLinkedHint:
        'This reimbursement will be paid to the linked vendor. Use Change to select another employee or vendor.',
      beneficiaryEmployeeHint:
        'When intake identifies the employee by email, they are automatically filled here.',
      beneficiaryUnresolvedHint:
        'We could not automatically identify an employee. Select an employee or vendor; if you approve without selecting one, a vendor will be created from the request data.',
      beneficiaryVendorSelectionHint:
        'Select an existing vendor. If left open when approving, a vendor will be created automatically when the request data has a CPF/CNPJ.',
      beneficiarySelectHint:
        'Selecting an employee or vendor replaces the previous beneficiary and saves automatically.',
      merchantSelectHint: 'Selection saved automatically.',
      merchantSelectHintFull:
        'Your selection is saved automatically. Use Change only if this reimbursement should be linked to another merchant.',
      merchantCreating: 'Creating vendor and linking it to the reimbursement...',
      merchantVendorLinked: 'Vendor linked',
      capturedMerchantLabel: 'Captured in intake',
      selectMerchantVendor: 'Select or create the vendor',
      attachmentsTitle: 'Attachments',
      attachmentsLoading: 'Loading attachments…',
      attachmentsEmpty: 'No attachments found.',
      attachmentsLoadFailed: 'Could not load attachments.',
      viewAttachment: 'View',
      viewAttachmentInline: 'View beside',
      viewAttachmentAriaSuffix: 'View attachment',
      attachmentViewerFailed: 'Could not open the file. Please try again.',
    },
    transaction: {
      title: 'Review transaction',
      transaction: 'Card transaction',
      apClassificationTitle: 'Classification',
      managerReviewTitle: 'Manager review',
      cardDataTitle: 'Card data',
      aiTitle: 'Automatic signal',
      aiSubtitle: 'Based on MCC, history, and vendor; used as support for the card category.',
      apClassificationHelp:
        'Shows the accounting classification for the transaction. If there is no classification yet, open the linked bill to finish it.',
      managerReviewHelp:
        'Records the manager review on the transaction. Acknowledged and improper do not change the accounting classification.',
      mccHelpLabel: 'What is MCC?',
      mccHelp:
        'MCC stands for Merchant Category Code. It is the merchant category code and helps suggest the transaction classification.',
      observation: 'Internal observation',
      observationPlaceholder: 'Record the classification rationale...',
      askCardholder: 'Ask card owner for info',
      askCardholderPlaceholder: 'Write the question for the card holder or card owner...',
      markImproperTitle: 'Register improper transaction reason',
      markImproperDescription:
        'Register the reason to guide the handling. No reconciliation action will be executed in the system.',
      markImproperReason: 'Reason',
      markImproperReasonPlaceholder: 'Describe why this transaction is improper...',
      annotations: 'Observation history',
      annotationAuthor: 'Unknown author',
      annotationTypes: {
        observation: 'Observation',
        financeQuestion: 'Question to card owner',
      },
    },
  },
  actions: {
    review: 'Review',
    reject: 'Reject',
    askInfo: 'Ask info',
    acknowledge: 'Aware',
    approve: 'Approve',
    close: 'Close',
    askCardholder: 'Ask card owner',
    improperShort: 'Improper',
    markImproper: 'Mark as improper',
    registerReason: 'Register reason',
    saveObservation: 'Save observation',
    manualApprovalSent: 'Reimbursement without policy approved.',
    policyManualApprovalSent: 'Policy reimbursement approved.',
    requestMoreInfoSent: 'Request emailed to submitter.',
    convertToBill: 'Generate AP bill',
    convertToBillDone: 'AP bill generated.',
    reEvaluatePolicy: 'Re-evaluate policy',
    policyReevaluated: 'Policy re-evaluated.',
    policyApplied: 'Policy applied.',
    reopenForReview: 'Reopen for review',
    reopenedForReview: 'Reimbursement reopened for manual review.',
  },
  approvalOrigin: {
    REIMBURSEMENT_POLICY: 'Policy',
    BILL_GENERIC_WORKFLOW: 'AP workflow',
    MANUAL_NO_POLICY: 'Manual',
    AUTO_APPROVE: 'Auto',
    CONVERTED_BILL: 'AP bill',
  },
  rejectDialog: {
    title: 'Reject reimbursement',
    description: 'Provide a rejection reason. This message is recorded on the approval workflow.',
    reasonLabel: 'Reason',
    placeholder: 'Describe why this request is being rejected…',
    confirm: 'Confirm rejection',
    cancel: 'Cancel',
    reasonRequired: 'A rejection reason is required.',
  },
  approveDialog: {
    title: 'Approve reimbursement',
    titleBulk: 'Approve {{count}} reimbursements',
    description:
      'Are you sure you want to approve this reimbursement? A bill will be generated automatically.',
    descriptionBulk:
      'Are you sure you want to approve the {{count}} selected reimbursements? A bill will be generated for each one.',
    commentLabel: 'Justification',
    reasonLabel: 'Justification',
    placeholder: 'Describe why this request is being approved…',
    confirm: 'Confirm approval',
    cancel: 'Cancel',
    processingTitle: 'Approving reimbursement',
    processingDescription: 'Please wait while we complete the approval.',
    successTitle: 'Reimbursement approved',
    successDescription: 'The approval completed successfully.',
    errorTitle: 'Unable to approve',
    complete: 'Done',
    retry: 'Try again',
    reasonRequired: 'An approval justification is required.',
  },
  reopenForReviewDialog: {
    title: 'Reopen for manual review',
    description:
      'The reimbursement will go back to the manager review queue, without auto-approving or auto-rejecting it. You can approve or reject it afterwards.',
    commentLabel: 'Note (optional)',
    placeholder: 'Describe why you are reopening this request…',
    confirm: 'Reopen for review',
    cancel: 'Cancel',
  },
  errors: {
    noPendingStep: 'No pending approval step for current user',
    noApproversConfigured:
      'No approver was found for this policy. Configure approval authorities or approvers before applying the policy.',
    approvalFailed: 'Approval failed',
    rejectionFailed: 'Rejection failed',
    reviewSaveFailed: 'Could not save review',
    dueDateSaveFailed: 'Could not save the expected date.',
    approvedAmountSaveFailed: 'Could not save the approved amount.',
    approvedAmountExceedsRequested:
      'Approved amount {{approved}} cannot exceed requested amount {{requested}}.',
    merchantSaveFailed: 'Could not save the establishment.',
    merchantCreateNeedsTaxId: 'Enter a valid CNPJ or CPF to create the vendor.',
    merchantCreateFailed: 'Could not create the vendor.',
    beneficiarySaveFailed: 'Could not save the beneficiary.',
    beneficiaryAutoCreateFailed:
      'Could not create the vendor automatically. Select a beneficiary before approving.',
    requestMoreInfoFailed: 'Could not send information request.',
    convertToBillFailed: 'Could not generate the AP bill.',
    policyReevaluationFailed: 'Could not re-evaluate the policy.',
    policyApplyFailed: 'Could not apply the policy.',
    reopenForReviewFailed: 'Could not reopen the reimbursement for review.',
    requestMoreInfoMessageRequired: 'Write the message that will be sent to the submitter.',
    forbidden:
      "You don't have permission to perform this action. Ask your administrator to grant access.",
    unauthorized: 'Your session expired. Please sign in again.',
  },
};
